import LanguageAndTimezone from '../components/language-and-timezone/language-and-timezone';

/* @ngInject */
export default function LangsAndTzController(
  _,
  StateManager,
  $scope,
) {
  const vm = this;

  vm.tabConfig = StateManager.accountSettingsTabs.find(tab => tab.state === 'language-and-timezone');
  $scope.LanguageAndTimezone = LanguageAndTimezone;

  return vm;
}
